import { PropTypes } from 'prop-types';
import React from 'react';

const TitleFeed = ({ title }) => {
  return (
    <div className="global-padding-container ">
      <h4 className="stink-h4">{title}</h4>
      <div className="pt-4 border-b border-smoke " />
    </div>
  );
};

TitleFeed.propTypes = {
  title: PropTypes.string,
};

export default TitleFeed;
